import { useAnalyticsActionTracker, useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { useTranslation } from 'react-i18next';
import { dashboardPagePath } from 'components/navigation/paths';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { getAbsoluteUrlWithParams } from '../utils/urlSearchParams';

export function useLogin(pathFn: () => string = dashboardPagePath, loginHint?: string): () => Promise<void> {
    const { login } = useOidcAuthentication();
    const { i18n } = useTranslation();
    const { pathname } = useLocation();
    const { onAction } = useAnalyticsActionTracker('login');

    const locale = i18n.languages[0];
    const redirectUri = getAbsoluteUrlWithParams(pathFn());

    return useCallback((): Promise<void> => {
        onAction(pathname);
        return login({
            redirect_uri: redirectUri,
            ui_locales: locale,
            login_hint: loginHint,
            redirectTarget: 'self',
            redirectMethod: 'assign',
        });
    }, [pathname, redirectUri, locale, loginHint, login, onAction]);
}
